module.exports = __webpack_public_path__ + "img/google.3ea40ccd.png";